import { Avatar, AvatarFallback, AvatarImage } from '@src/design-system/avatar';
import memberApi from '@src/shared/services/member-api';

export type ChipValueRendererProps = {
  id: string | number;
  fieldName: string;
};

export const ChipMemberValue = ({ id }: ChipValueRendererProps) => {
  const { data } = memberApi.useFetch({ user: id });
  const member = data?.results?.[0];
  const user = member?.user;

  return (
    <>
      <Avatar className='size-3'>
        <AvatarImage src={user?.avatar} />
        <AvatarFallback colorId={user?.id as number}>
          {user?.first_name[0]}
        </AvatarFallback>
      </Avatar>
      {user?.first_name}
    </>
  );
};
